import src from "IMAGE";
export default { src, width: 250, height: 90, blurWidth: 0, blurHeight: 0};
